export default __webpack_public_path__ + "static/media/img_fukidashi_black.5a5c941d.svg";